const LOGIN_MODE = Object.freeze({ CODE: 0, PHONE: 1, EMAIL_LOGIN: 2, EMAIL_SIGNUP: 3, SCAN: 4, PHONE_MERGE: 5 });
const LOGIN_FORM_MODE = Object.freeze({ LOGIN: 0, MERGE: 1 });

const APP_MODE = Object.freeze({ WEB: 0, APP: 1, KIOSK: 2 });

const PAY_METHOD = Object.freeze({ PAY_HERE: 0, PAY_AT_COUNTER: 1, PAY_BY_GIFT_CARD: 2, PAY_BY_POINTS: 3 });

const MENU_TYPE = Object.freeze({
  DINEIN: "dinein",
  TAKEOUT: "takeout",
  DELIVERY: "delivery",
  KIOSK: "kiosk",
  ORDERPAD: "orderpad",
});
const ORDER_TYPE = Object.freeze({ DINEIN: "dinein", MENU: "menu", TAKEOUT: "takeout", DELIVERY: "delivery" });

const NEWSFEED_DISPLAY = Object.freeze({ VERTICAL: 0, HORIZONTAL: 1, CAROUSEL: 2 });

export { LOGIN_MODE, LOGIN_FORM_MODE, APP_MODE, PAY_METHOD, MENU_TYPE, ORDER_TYPE, NEWSFEED_DISPLAY };
